import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./privacy.css";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";

export default class Privacy extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    
    render() {
        return (
            <div>
                <div className="home">
                    <div class="position-relative overflow-hidden p-3 mb-5 mt-5 text-center bg-light">
                        <div class="col-md-5 mx-auto my-5">
                            <h1 class="display-4 font-weight-normal">Privacy Policy</h1>
                            <p class="lead font-weight-normal">&nbsp;</p>
                        </div>
                        <div class="product-device shadow-sm d-none d-md-block"></div>
                        <div class="product-device product-device-2 shadow-sm d-none d-md-block"></div>
                    </div>

                    <div class="container mb-5 terms-conditions">
                        <h4 class="mt-4">Introduction</h4>
                        <p class="lead text-justify">
                            Welcome to Ambrum Solutions (Pvt) Ltd. We are committed to protecting your privacy and ensuring transparency in how we collect, use, store, and share your information. This Privacy Policy explains how we handle your data in compliance with Google Play Store policies, Apple App Store privacy guidelines, Personal Data Protection Act, No. 9 of 2022, the General Data Protection Regulation (GDPR), and other applicable data protection laws.
                        </p>

                        <h4 class="mt-4">Identity and Contact Information</h4>
                        <ul>
                            <li><b>Entity Name:</b> Ambrum Solutions (Pvt) Ltd.</li>
                            <li><b>Contact Email:</b> info@ambrumsolutions.com</li>
                            <li><b>Data Protection Officer (DPO):</b> privacy@ambrumsolutions.com</li>
                        </ul>

                        <h4 class="mt-4">How We Collect Your Data</h4>
                        <p class="lead text-justify">
                            We collect data in the following ways:
                        </p>
                        <ul>
                            <li><b>Directly from Users:</b> When you sign up, provide information, or interact with the app.</li>
                            <li><b>Automatically:</b> Through cookies, logs, tracking tools, and analytics services.</li>
                            <li><b>From Third Parties:</b> If integrated with third-party services or SDKs</li>
                        </ul>

                        <h4 class="mt-4">What Data We Collect</h4>
                        <p class="lead text-justify">
                            We may collect the following types of information:
                        </p>
                        <ul>
                            <li><b>Personal Information:</b> Name, email, phone number, and other details you provide.</li>
                            <li><b>Device Information:</b> IP address, device type, operating system, unique identifiers, and app usage data.</li>
                            <li><b>Location Data:</b> Precise or approximate location data, if permission is granted.</li>
                            <li><b>User Content:</b> Messages, photos, videos, and other uploaded content.</li>
                            <li><b>Browsing and Search History:</b> Data on app interactions and search queries.</li>
                            <li><b>Financial Information:</b> Financial Information.</li>
                        </ul>


                        <h4 class="mt-4">Purpose and Legal Basis for Data Processing</h4>
                        <p class="lead text-justify">
                            We process data under the following legal bases:
                        </p>
                        <ul>
                            <li><b>Contractual Necessity:</b> To provide app functionality and services.</li>
                            <li><b>Legitimate Interests:</b> To improve app performance, user experience, and security.</li>
                            <li><b>Consent:</b> For optional data collection, marketing communications, and targeted ads.</li>
                            <li><b>Legal Obligation:</b> To comply with legal and regulatory requirements.</li>
                        </ul>


                        <h4 class="mt-4">How We Share Your Data</h4>
                        <p class="lead text-justify">
                            We do not sell personal or sensitive data. We may share your data:
                        </p>
                        <ul>
                            <li><b>With Service Providers:</b> Who assist with app operations, hosting, customer support, and analytics.</li>
                            <li><b>For Legal Compliance:</b> If required by law, regulatory authorities, or in response to legal requests.</li>
                            <li><b>During Business Transactions:</b> Such as mergers, acquisitions, or asset sales, with appropriate notice.</li>
                        </ul>

                        <h4 class="mt-4">Data Tracking and Third-Party Services</h4>
                        <ul>
                            <li><b>Tracking Technologies:</b> We may use tracking identifiers for analytics, functionality, and advertising.</li>
                            <li><b>Third-Party SDKs:</b> Integrated services may collect and process data according to their privacy policies.</li>
                            <li><b>Compliance with Google and Apple Guidelines:</b> We adhere to the respective privacy policies of Google Play Store and Apple App Store.</li>
                        </ul>


                        <h4 class="mt-4">International Data Transfers</h4>
                        <p class="lead text-justify">
                            If data is transferred outside your jurisdiction, we implement safeguards such as:
                        </p>
                        <ul>
                            <li>Standard Contractual Clauses (SCCs)</li>
                            <li>Adequacy decisions under applicable laws</li>
                            <li>Binding Corporate Rules (BCRs)</li>
                        </ul>

                        <h4 class="mt-4">Data Security and Retention</h4>
                        <ul>
                            <li>Data is securely stored using encryption and security best practices.</li>
                            <li>We retain data only as long as necessary for app functionality, legal compliance, or business purposes.</li>
                            <li>Users can request data deletion via in-app settings or by contacting privacy@ambrumsolutions.com.</li>
                        </ul>

                        <h4 class="mt-4"><b>Your Rights Under GDPR, CCPA, and Other Laws</b> Depending on your location, you have the following rights:</h4>
                        <ul>
                            <li><b>Right to Access:</b> Request a copy of your data.</li>
                            <li><b>Right to Rectification:</b> Correct inaccuracies in your data.</li>
                            <li><b>Right to Erasure:</b> Request deletion of your data.</li>
                            <li><b>Right to Restrict Processing:</b> Limit how your data is processed.</li>
                            <li><b>Right to Data Portability:</b> Transfer your data to another provider.</li>
                            <li><b>Right to Object:</b> Opt-out of certain types of data processing.</li>
                            <li><b>Right to Withdraw Consent:</b> Withdraw consent for data use where applicable.</li>
                            <li><b>Right to Opt-Out of Tracking:</b> Manage tracking preferences in app settings.</li>
                            <li><b>Right to Lodge a Complaint:</b> Contact a data protection authority.</li>
                        </ul>

                        <h4 class="mt-4">Children's Privacy</h4>
                        <p class="lead text-justify">
                            Our app is not intended for children under 13. If we unknowingly collect data from a child, we will delete it immediately. We comply with Google's and Apple's child privacy policies when applicable.
                        </p>

                        <h4 class="mt-4">Changes to This Privacy Policy</h4>
                        <p class="lead text-justify">
                            We may update this Privacy Policy from time to time to reflect changes in legal requirements or our data practices. Users will be notified of any significant changes through in-app alerts or email.
                        </p>

                        <h4 class="mt-4">Contact Us</h4>
                        <p class="lead text-justify">
                            If you have any questions or concerns about this Privacy Policy, please contact us at: <a href="mailto:privacy@ambrumsolutions.com">privacy@ambrumsolutions.com</a>.
                        </p>

                    </div>
                    <ContactUsFooter />
                </div>
                <Footer />
            </div>

        );
    }
}
